import React from "react";
import { Routes, Route } from "react-router-dom";
import PathList from "./PathList";
import { Middleware } from "../Config/MiddleWare";
import Dashboard from "../Screens/Dashboard/Dashboard";
import LoginScreen from "../Screens/LoginScreen";
import Layout from "../Layout/Layout";
import ManageNews from "../Screens/ManageNews/ManageNews";
import ManagePlayers from "../Screens/ManagePlayers/ManagePlayers";
import ManageClub from "../Screens/ManageClub/ManageClub";
import ClubDetails from "../Screens/ClubDetails/ClubDetails";
import CenterManagement from "../Screens/CenterManagement/CenterManagement";
import AddNewReport from "../Screens/AddNewReport/AddNewReport";
import ManageFixtures from "../Screens/ManageFixtures/ManageFixtures";
import ManageUser from "../Screens/ManageUser/ManageUser";

const RouteList = () => {
  return (
    <Routes>
      <Route path={PathList.Login} element={<LoginScreen />} />
      <Route
        path={PathList.Dashboard}
        element={<Middleware children={<Layout element={<Dashboard />} />} />}
      />
      <Route
        path={PathList.ManageNews}
        element={<Middleware children={<Layout element={<ManageNews />} />} />}
      />
      <Route
        path={PathList.ManagePlayer}
        element={<Middleware children={<Layout element={<ManagePlayers />} />} />}
      />
      <Route
        path={PathList.ManageClub}
        element={<Middleware children={<Layout element={<ManageClub />} />} />}
      />
      <Route
        path={PathList.ClubDetails}
        element={<Middleware children={<Layout element={<ClubDetails />} />} />}
      />
      <Route
        path={PathList.CenterManagement}
        element={<Middleware children={<Layout element={<CenterManagement />} />} />}
      />
      <Route
        path={PathList.AddNewReport}
        element={<Middleware children={<Layout element={<AddNewReport />} />} />}
      />
      <Route
        path={PathList.ManageFixtures}
        element={<Middleware children={<Layout element={<ManageFixtures />} />} />}
      />
      <Route
        path={PathList.ManageUser}
        element={<Middleware children={<Layout element={<ManageUser />} />} />}
      />
     
    </Routes>
  );
};

export default RouteList;
